<template>
  <div class="modal-backdrop">
    <div
      class="modal flex max-h-[min(92vh,100svh)] flex-col overflow-hidden bg-surface text-ink shadow-2xl drop-shadow-2xl rounded-lg relative"
      :class="{ 'w-[30%]': sm, 'w-[50%]': md, 'w-[70%]': lg, customWidthClass }"
    >
      <div
        v-if="loading"
        class="absolute inset-0 bg-surface flex items-center justify-center z-[100]"
      >
        <span
          class="border-[4px] border-primary rounded-full w-10 h-10 animate-spin border-r-transparent"
        ></span>
      </div>
      <div class="relative flex shrink-0 items-center justify-between p-4 modal-header">
        <div class="flex items-center gap-2" v-if="!customTitle">
          <h4 class="text-lg text-ink">{{ title }}</h4>
        </div>
        <slot name="title" v-else></slot>
        <slot name="header-right" />
        <button class="bg-transparent hover:brightness-[70%] rounded-full" v-if="showCloseButton">
          <XMarkIcon class="size-6 text-ink-soft" @click="closeEvent" />
        </button>
      </div>
      <hr class="border-line" />
      <div
        class="modal-body min-h-0 flex-1 overflow-y-auto p-4 pt-2 [scrollbar-gutter:stable] mt-2"
      >
        <slot name="modal-content"></slot>
      </div>
      <hr class="border-line" />
      <div class="modal-footer flex shrink-0 justify-end p-4" v-if="showFooter !== false">
        <template v-if="customFooter">
          <slot name="footer"></slot>
        </template>
        <template v-else>
          <button
            class="bg-surface-3 rounded-md text-ink px-2 py-2"
            :class="{ 'mr-2': showSaveButton }"
            @click="cancelEvent"
            v-if="showCancelButton"
          >
            {{ cancelButtonText ?? 'Cancel' }}
          </button>
          <button
            class="bg-primary rounded-md text-white px-2 py-2"
            :class="saveButtonDisabled ? 'opacity-50 cursor-not-allowed' : ''"
            @click="saveEvent"
            v-bind="saveButtonProps"
            :disabled="saveButtonDisabled"
            v-if="showSaveButton"
          >
            {{ saveButtonText ?? 'Save' }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';
import { ButtonHTMLAttributes, defineEmits, defineProps } from 'vue';

defineProps<{
  title: string;
  showCloseButton: boolean;
  showFooter?: boolean;
  customFooter?: boolean;
  customTitle?: boolean;
  showSaveButton?: boolean;
  showCancelButton?: boolean;
  saveButtonText?: string;
  cancelButtonText?: string;
  md?: boolean;
  sm?: boolean;
  lg?: boolean;
  customWidthClass?: string;
  saveButtonProps?: ButtonHTMLAttributes;
  saveButtonDisabled?: boolean;
  loading?: boolean;
}>();

const emit = defineEmits(['closeEvent', 'saveEvent', 'cancelEvent']);

const cancelEvent = () => emit('cancelEvent');
const closeEvent = () => emit('closeEvent');
const saveEvent = () => {
  emit('saveEvent');
};
</script>
<style scoped lang="scss"></style>
